import React from 'react'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import useStyles from './Style'

import DataItem from './DataItem'

const DadosInscricao = ({ inscricao }) => {
    const classes = useStyles();
    return (
        <div className={classes.section}>
            <Typography className={classes.title}>Dados da Inscrição</Typography>
            <Grid container spacing={2}>
                <DataItem label="Código de Inscrição" value={inscricao.codigo} sm={4} />
                <DataItem label="Data de Finalização" value={inscricao.dataFinalizacaoInscricao} sm={4} />
                {inscricao.precisaRealizarPagamento && (
                    <DataItem 
                        label="Valor à Pagar" 
                        value={`R$ ${inscricao.valorPagar}`} 
                        sm={4} 
                        valueClassName={classes.highlightValue}
                    />
                )}

                {inscricao.localProvaConfirmado.municipio && (
                    <>
                        <DataItem 
                            label="Município Confirmado para Realização da Prova" 
                            value={`${inscricao.localProvaConfirmado.municipio} - ${inscricao.localProvaConfirmado.uf}`} 
                            sm={8} 
                        />
                        <DataItem 
                            label="Data de Confirmação" 
                            value={inscricao.localProvaConfirmado.dataConfirmacao} 
                            sm={4} 
                        />
                    </>
                )}
            </Grid>
        </div>
    )
}

export default DadosInscricao;
